import { render, staticRenderFns } from "./RemoveManagerContractorRequestResources.vue?vue&type=template&id=6bc9ea63"
import script from "./RemoveManagerContractorRequestResources.vue?vue&type=script&lang=ts"
export * from "./RemoveManagerContractorRequestResources.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bc9ea63')) {
      api.createRecord('6bc9ea63', component.options)
    } else {
      api.reload('6bc9ea63', component.options)
    }
    module.hot.accept("./RemoveManagerContractorRequestResources.vue?vue&type=template&id=6bc9ea63", function () {
      api.rerender('6bc9ea63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/RemoveManagerContractorRequestResources.vue"
export default component.exports